// extracted by css-extract-rspack-plugin
export default {"packageLabelsList":"pb9T8hJ6d0gl24WW"};